"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DomainsTable;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _table = _interopRequireWildcard(require("@ux/table"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTable = require("@tanstack/react-table");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _textInput = _interopRequireDefault(require("@ux/text-input"));
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RootContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "RootContainer",
  class: "pl-r1yj8lx5"
});
const SectionHeader = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SectionHeader",
  class: "pl-s86c68h"
});
const SubHead = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SubHead",
  class: "pl-s1sd0iw2"
});
const FormElementColorized = /*#__PURE__*/(0, _react2.styled)(_textInput.default)({
  name: "FormElementColorized",
  class: "pl-f1chxwwp"
});
const MoreButton = /*#__PURE__*/(0, _react2.styled)(_merchButton.NSMerchButton)({
  name: "MoreButton",
  class: "pl-mgca2h3"
});
const TableSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "TableSection",
  class: "pl-t1c1rb40"
});
const initialSort = (left, right) => {
  const a = left.orderIdx;
  const b = right.orderIdx;
  if (a < b) return -1;
  if (a > b) return 1;
  return left.tld < right.tld ? -1 : 1;
};

/**
 * DomainsTable component.
 * @module DomainsTable
 *
 * @param {Object} props React props
 * @param {string} props.orderOfTopTlds String of top TLDs
 * @param {string} props.headline Headline text
 * @param {string} props.headlineTag HTML tag to use for headline text
 * @param {string} props.filterPlaceholder filter placeholder text
 * @param {string} props.subHead the text before the filter input box
 * @param {string} props.noResults message when no results
 * @param {string} props.domainExtensionColumn Column Heading: domain name
 * @param {string} props.listPriceColumn Column Heading: list price
 * @param {string} props.basicPriceColumn Column Heading: basic price
 * @param {string} props.premiumPriceColumn Column Heading: premium price
 * @param {string} props.proPriceColumn Column Heading: pro price
 * @param {string} props.expansionLink Link text to expand out all domains in list
 * @param {Array} props.domainsArray Array of domains
 * @param {string} props.disclaimer disclaimer text
 * @param {string} props.verticalMargin Vertical Spacing value
 * @public
 */

function DomainsTable({
  id,
  orderOfTopTlds,
  heading,
  headlineTag = 'h2',
  filterPlaceholder,
  subHead,
  noResults,
  domainExtensionColumn,
  proPriceColumn,
  listPriceColumn,
  basicPriceColumn,
  premiumPriceColumn,
  expansionLink,
  disclaimer,
  domains = [],
  initialRowsInTable = 5,
  verticalMargin = 'none',
  qtyVisibleBasic = 20,
  qtyVisiblePremium = 40
}) {
  const lengthOfOrderOfTopTlds = (0, _react.useMemo)(() => orderOfTopTlds?.split(',').length || 0, [orderOfTopTlds]);
  const columns = (0, _react.useMemo)(() => [{
    id: 'tld',
    accessorFn: row => `.${row.tld}`,
    header: () => domainExtensionColumn,
    sortingFn: 'alphanumeric'
  }, {
    header: () => listPriceColumn,
    id: 'listPrice',
    accessorKey: 'listPrice.raw',
    sortingFn: 'alphanumeric',
    cell: ({
      row
    }) => row.original?.listPrice?.formatted
  }, {
    header: () => basicPriceColumn,
    id: 'basicPrice',
    // AccessorFn uses raw values bc we sort based on the accessor's return value
    accessorFn: (originalRow, index) => index < lengthOfOrderOfTopTlds && index < qtyVisibleBasic ? originalRow.basicPrice.raw :
    // eslint-disable-next-line no-undefined
    undefined,
    sortingFn: 'alphanumeric',
    sortUndefined: 'last',
    cell: ({
      cell,
      row
    }) => cell.getValue() && row.original?.basicPrice?.formatted
  }, {
    header: () => premiumPriceColumn,
    id: 'premiumPrice',
    accessorFn: (originalRow, index) => index < lengthOfOrderOfTopTlds && index < qtyVisiblePremium ? originalRow.premiumPrice.raw :
    // eslint-disable-next-line no-undefined
    undefined,
    sortingFn: 'alphanumeric',
    sortUndefined: 'last',
    cell: ({
      cell,
      row
    }) => cell.getValue() && row.original?.premiumPrice?.formatted
  }, {
    header: () => proPriceColumn,
    id: 'proPrice',
    sortingFn: 'alphanumeric',
    accessorKey: 'proPrice.raw',
    cell: ({
      row
    }) => row.original?.proPrice?.formatted
  }], [qtyVisibleBasic, qtyVisiblePremium, lengthOfOrderOfTopTlds]);
  const [limitSize, setLimitSize] = (0, _react.useState)(initialRowsInTable);
  const [tableData, setTableData] = (0, _react.useState)(() => [...(domains || []).sort(initialSort).slice(0, limitSize)]);
  const [sorting, setSorting] = (0, _react.useState)([]);
  const [globalFilter, setGlobalFilter] = (0, _react.useState)('');
  const table = (0, _reactTable.useReactTable)({
    data: tableData,
    columns,
    state: {
      sorting,
      globalFilter
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: 'includesString',
    getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
    getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
    getFilteredRowModel: (0, _reactTable.getFilteredRowModel)()
  });
  const showMoreButton = globalFilter.length === 0 && (tableData.length < (domains?.length || 0) || limitSize !== 0 && limitSize < (domains?.length || 0));
  const expansionLinkFormatted = expansionLink.replace('{0}', domains?.length || 0);
  const expandTable = () => {
    setLimitSize(domains?.length || 0);
  };
  (0, _react.useEffect)(() => {
    setTableData([...(domains || []).sort(initialSort).slice(0, limitSize)]);
  }, [limitSize]);
  return /*#__PURE__*/_react.default.createElement(RootContainer, {
    verticalMargin: verticalMargin,
    padding: "none",
    textAlign: "center",
    dataCy: "domains-table-section"
  }, /*#__PURE__*/_react.default.createElement(SectionHeader, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: heading,
    headlineTag: headlineTag
  }), /*#__PURE__*/_react.default.createElement(SubHead, null, subHead), /*#__PURE__*/_react.default.createElement(FormElementColorized, {
    id: `ddc-filter-${id}`,
    value: globalFilter ?? '',
    onChange: value => {
      setGlobalFilter(String(value));
      expandTable();
    },
    placeholder: filterPlaceholder
  })), /*#__PURE__*/_react.default.createElement(TableSection, {
    textAlign: "start",
    padding: "none",
    dataCy: "domains-table-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_table.default, {
    className: "table table-hover"
  }, /*#__PURE__*/_react.default.createElement(_table.Thead, null, table.getHeaderGroups().map(headerGroup => /*#__PURE__*/_react.default.createElement(_table.Tr, {
    key: headerGroup.id
  }, headerGroup.headers.map(header => {
    const sortDir = header.column.getIsSorted();
    const ariaSort = sortDir ? sortDir.replace(/(asc|desc)(?:ending)?/, '$1ending') : null;
    return /*#__PURE__*/_react.default.createElement("th", {
      key: header.id,
      "aria-sort": ariaSort,
      colSpan: header.colSpan,
      className: "ux-th"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ux-table-cell-container"
    }, /*#__PURE__*/_react.default.createElement(_text.default.button, {
      as: "action",
      className: 'ux-sort-header-button',
      onClick: header.column.getToggleSortingHandler()
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ux-sort-header-button-container"
    }, (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext()), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "arrow-down",
      className: "ux-sort-arrow"
    })))));
  })))), /*#__PURE__*/_react.default.createElement(_table.Tbody, null, table.getRowModel().rows.map(row => /*#__PURE__*/_react.default.createElement(_table.Tr, {
    key: row.id
  }, row.getVisibleCells().map(cell => /*#__PURE__*/_react.default.createElement("td", {
    key: cell.id,
    className: cell.column.id
  }, (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())))))))), table.getRowModel().rows.length === 0 && /*#__PURE__*/_react.default.createElement("p", null, noResults), showMoreButton && /*#__PURE__*/_react.default.createElement(MoreButton, {
    text: expansionLinkFormatted,
    onClick: expandTable,
    design: "inline",
    size: "default",
    "data-cy": "more-button"
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, null, disclaimer));
}
DomainsTable.propTypes = {
  heading: _propTypes.default.string,
  headlineTag: _propTypes.default.string,
  filterPlaceholder: _propTypes.default.string,
  subHead: _propTypes.default.string,
  noResults: _propTypes.default.string,
  domainExtensionColumn: _propTypes.default.string,
  listPriceColumn: _propTypes.default.string,
  basicPriceColumn: _propTypes.default.string,
  premiumPriceColumn: _propTypes.default.string,
  expansionLink: _propTypes.default.string,
  disclaimer: _propTypes.default.string,
  domains: _propTypes.default.arrayOf(_propTypes.default.shape({
    tld: _propTypes.default.string.isRequired,
    orderIdx: _propTypes.default.number.isRequired,
    isBasic: _propTypes.default.bool.isRequired,
    listPrice: _propTypes.default.object.isRequired,
    basicPrice: _propTypes.default.object,
    premiumPrice: _propTypes.default.object.isRequired,
    proPrice: _propTypes.default.object
  })).isRequired,
  orderOfTopTlds: _propTypes.default.string,
  initialRowsInTable: _propTypes.default.number,
  visibleQtyPerColumn: _propTypes.default.object,
  ..._patternLibraryUtils.marginProps
};